import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { EXERCISE_DURATION_UNIT } from "@/lib/constants";
import styles from "@/styles/Video.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RightViewTerm(_ref) {
  var right = _ref.right;
  if (!right) return null;

  var _rightViewTerm = rightViewTerm(right),
      _rightViewTerm2 = _slicedToArray(_rightViewTerm, 2),
      label = _rightViewTerm2[0],
      text = _rightViewTerm2[1];

  if (!label) return null;
  return /*#__PURE__*/_jsxs("span", {
    className: styles.rightViewLimit,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.label,
      children: label
    }), /*#__PURE__*/_jsx("span", {
      children: text
    })]
  });
}
export function rightViewTerm(right) {
  if (right !== null && right !== void 0 && right.exercise_term) {
    var _EXERCISE_DURATION_UN;

    return ["視聴可能期間", "\u8996\u8074\u958B\u59CB\u5F8C".concat(right.exercise_term).concat((_EXERCISE_DURATION_UN = EXERCISE_DURATION_UNIT[right === null || right === void 0 ? void 0 : right.exercise_term_unit]) === null || _EXERCISE_DURATION_UN === void 0 ? void 0 : _EXERCISE_DURATION_UN.label)];
  } else if (right !== null && right !== void 0 && right.view_limit_date) {
    return ["視聴期間", "\u6C7A\u6E08\u65E5\u304B\u3089".concat(right.view_limit_date, "\u307E\u3067")];
  }

  return [];
}